"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountTailoredPageTour = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var inversify_react_1 = require("inversify-react");
var react_transition_group_1 = require("react-transition-group");
var event_tracker_types_1 = require("@qwilr/event-tracker-types");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var OnboardingTypes_1 = require("Onboarding/OnboardingTypes");
var PromptTypes_1 = require("Prompt/PromptTypes");
var TailoredPageTourPrompt_1 = __importDefault(require("./TailoredPageTourPrompt"));
var styles = __importStar(require("./TailoredPageTourPrompt.css"));
var prompts = [PromptTypes_1.PromptId.TailoredPageAddBlock, PromptTypes_1.PromptId.TailoredPageSelectContent, PromptTypes_1.PromptId.TailoredPageCollaborate];
var getClickableElement = function (promptId) {
    switch (promptId) {
        case PromptTypes_1.PromptId.TailoredPageAddBlock:
            return document.querySelector(".prompt-target--create-block");
        case PromptTypes_1.PromptId.TailoredPageSelectContent:
            return document.querySelector(".project-block img");
        case PromptTypes_1.PromptId.TailoredPageCollaborate:
            return document.querySelector(".prompt-target--collaborate");
        default:
            throw new Error("Invalid promptId");
    }
};
var getTargetElement = function (promptId) {
    switch (promptId) {
        case PromptTypes_1.PromptId.TailoredPageAddBlock:
            return document.querySelector(".add-block-menu");
        case PromptTypes_1.PromptId.TailoredPageSelectContent:
            return document.querySelector(".project-block img");
        case PromptTypes_1.PromptId.TailoredPageCollaborate:
            return document.querySelector(".prompt-target--collaborate-copy-link");
        default:
            throw new Error("Invalid promptId");
    }
};
var getTooltipPosition = function (promptId) {
    switch (promptId) {
        case PromptTypes_1.PromptId.TailoredPageAddBlock:
            return "top";
        case PromptTypes_1.PromptId.TailoredPageSelectContent:
        case PromptTypes_1.PromptId.TailoredPageCollaborate:
            return "left";
        default:
            throw new Error("Invalid promptId");
    }
};
var getTooltipOffset = function (promptId) {
    switch (promptId) {
        case PromptTypes_1.PromptId.TailoredPageAddBlock:
        case PromptTypes_1.PromptId.TailoredPageSelectContent:
            return 16;
        case PromptTypes_1.PromptId.TailoredPageCollaborate:
            return 32;
        default:
            throw new Error("Invalid promptId");
    }
};
var getPromptTitle = function (promptId) {
    switch (promptId) {
        case PromptTypes_1.PromptId.TailoredPageAddBlock:
            return "Welcome to Qwilr!";
        case PromptTypes_1.PromptId.TailoredPageSelectContent:
            return "Select images and text to format, update colors, and more.";
        case PromptTypes_1.PromptId.TailoredPageCollaborate:
            return "Get feedback";
        default:
            throw new Error("Invalid promptId");
    }
};
var getPromptEmoji = function (promptId) {
    switch (promptId) {
        case PromptTypes_1.PromptId.TailoredPageAddBlock:
            return "🎉";
        case PromptTypes_1.PromptId.TailoredPageSelectContent:
            return undefined;
        case PromptTypes_1.PromptId.TailoredPageCollaborate:
            return "🤩";
        default:
            throw new Error("Invalid promptId");
    }
};
var getPromptBody = function (promptId) {
    switch (promptId) {
        case PromptTypes_1.PromptId.TailoredPageAddBlock:
            return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m" },
                react_1.default.createElement(kaleidoscope_1.Text, { element: "p", size: "m", strong: true, className: styles.text }, "Your first page is ready to edit."),
                react_1.default.createElement(kaleidoscope_1.Text, { element: "p", size: "m", className: styles.text },
                    "Add new content with the ",
                    react_1.default.createElement(icons_1.Add, { "aria-label": "plus", size: icons_1.IconSize.Small, className: styles.addIcon }),
                    " at the top and bottom of each block.")));
        case PromptTypes_1.PromptId.TailoredPageSelectContent:
            return undefined;
        case PromptTypes_1.PromptId.TailoredPageCollaborate:
            return (react_1.default.createElement(kaleidoscope_1.Text, { element: "p", size: "m", className: styles.text }, "Click Collaborate and send the link to a colleague to get feedback."));
        default:
            throw new Error("Invalid promptId");
    }
};
var getButtonText = function (promptId) {
    switch (promptId) {
        case PromptTypes_1.PromptId.TailoredPageAddBlock:
        case PromptTypes_1.PromptId.TailoredPageSelectContent:
            return (react_1.default.createElement(react_1.default.Fragment, null,
                "Next",
                react_1.default.createElement(icons_1.ArrowRight, null)));
        case PromptTypes_1.PromptId.TailoredPageCollaborate:
            return "Got it";
        default:
            throw new Error("Invalid promptId");
    }
};
var TailoredPageTour = function () {
    var useHistoryDataStore = (0, inversify_react_1.useInjection)("rootDataStore").userDataStore.useHistoryDataStore;
    var serverTelemetry = (0, inversify_react_1.useInjection)("serverTelemetry");
    var _a = __read((0, react_1.useState)(-1), 2), currentPromptIndex = _a[0], setCurrentPromptIndex = _a[1];
    var completeTour = function () {
        setCurrentPromptIndex(-1);
        useHistoryDataStore.completeOnboardingSequence(OnboardingTypes_1.SequenceName.TailoredPageTour);
    };
    var goToPrompt = function (index) {
        var nextPrompt = prompts[index];
        var clickableElement = getClickableElement(nextPrompt);
        clickableElement === null || clickableElement === void 0 ? void 0 : clickableElement.scrollIntoView({ behavior: "smooth", block: "end" });
        clickableElement === null || clickableElement === void 0 ? void 0 : clickableElement.click();
        setCurrentPromptIndex(index);
    };
    var goToNext = function () {
        serverTelemetry.sendProductTourStepCompletedTelemetry({
            eventProperties: { stepNumber: currentPromptIndex + 1 },
            eventOrigin: event_tracker_types_1.EventOrigin.QwilrDashboard,
        });
        var nextPromptIndex = currentPromptIndex + 1;
        if (!prompts[nextPromptIndex]) {
            return completeTour();
        }
        goToPrompt(nextPromptIndex);
    };
    var dismissPrompt = function () {
        serverTelemetry.sendProductTourDismissedTelemetry({
            eventProperties: { stepNumber: currentPromptIndex + 1 },
            eventOrigin: event_tracker_types_1.EventOrigin.QwilrDashboard,
        });
        completeTour();
    };
    (0, react_1.useEffect)(function () {
        var delayTourStart = setTimeout(function () {
            goToPrompt(0);
        }, 2000);
        return function () {
            clearTimeout(delayTourStart);
        };
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null, prompts.map(function (prompt, index) { return (react_1.default.createElement(react_transition_group_1.Transition, { key: prompt, mountOnEnter: true, unmountOnExit: true, in: index === currentPromptIndex, timeout: kaleidoscope_1.AnimationDuration.Medium }, function (status) {
        return (0, react_dom_1.createPortal)(react_1.default.createElement(TailoredPageTourPrompt_1.default, { targetElement: getTargetElement(prompt), tooltipPosition: getTooltipPosition(prompt), tooltipOffset: getTooltipOffset(prompt), transitionStatus: status, title: getPromptTitle(prompt), emoji: getPromptEmoji(prompt), body: getPromptBody(prompt), buttonText: getButtonText(prompt), promptIndex: index, promptCount: prompts.length, confetti: index === 0, onAcceptPrompt: goToNext, onDismissPrompt: dismissPrompt, onGoToPrompt: goToPrompt }), (0, utils_1.getPortalRoot)("tailored-page-tour-prompt"));
    })); })));
};
var mountTailoredPageTour = function (mountReactComponent) {
    return mountReactComponent(react_1.default.createElement(TailoredPageTour, null));
};
exports.mountTailoredPageTour = mountTailoredPageTour;
